import { render } from "./BaseTopAppBar.vue?vue&type=template&id=0683f753"
import script from "./BaseTopAppBar.vue?vue&type=script&lang=js"
export * from "./BaseTopAppBar.vue?vue&type=script&lang=js"

import "./BaseTopAppBar.vue?vue&type=style&index=0&id=0683f753&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__